import React from 'react';
import Icon from '../../ui/Icon';

export default function PendingApprovalsWidget({ approvals = [], onItemClick }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#2D3748' }}>My Pending Approvals</div>
        <div style={{ fontSize: 12, fontWeight: 600, color: '#2563eb', background: '#eff6ff', padding: '2px 8px', borderRadius: 12 }}>{approvals.length}</div>
      </div>
      
      {approvals.length === 0 ? (
        <div style={{ padding: '20px 0', textAlign: 'center', color: '#718096', fontSize: 13 }}>No pending approvals</div>
      ) : (
        approvals.map((approval, i) => (
          <div
            key={i}
            role={onItemClick ? 'button' : undefined}
            tabIndex={onItemClick ? 0 : undefined}
            onClick={onItemClick ? (e) => { e.stopPropagation(); onItemClick(approval); } : undefined}
            style={{
              display: 'flex', flexDirection: 'column', gap: 6, padding: '10px',
              background: '#FFFFFF', border: '1px solid #f3f4f6', borderRadius: 8,
              cursor: onItemClick ? 'pointer' : 'default',
              transition: 'border-color 0.15s, box-shadow 0.15s',
            }}
            onMouseEnter={onItemClick ? (e) => { e.currentTarget.style.borderColor = '#3B5BDB'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(59,91,219,0.12)'; } : undefined}
            onMouseLeave={onItemClick ? (e) => { e.currentTarget.style.borderColor = '#f3f4f6'; e.currentTarget.style.boxShadow = 'none'; } : undefined}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1A202C' }}>{approval.id}</div>
              <div style={{ fontSize: 11, color: '#718096', display: 'flex', alignItems: 'center', gap: 4 }}><Icon name="clock" size={12} /> {approval.time}</div>
            </div>
            <div style={{ fontSize: 12, color: '#4b5563' }}>{approval.title}</div>
            <div style={{ fontSize: 11, color: '#718096' }}>Requested by: <span style={{ fontWeight: 500, color: '#2D3748' }}>{approval.requester}</span></div>
          </div>
        ))
      )}
    </div>
  );
}
